import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CapitalizePipe, PluralPipe, RoundPipe, TimingPipe, NumberWithCommasPipe } from "./pipes";
import { SharedModule } from "../shared/shared.module";
import { CallinfoComponent } from "./components/header/callinfo/callinfo.component";
import { HeaderComponent } from "./components/header/header.component";
import { ImportAndExportComponent } from "./components/header/importandexport/importexport.component";
import { backUpComponent } from "./components/header/backup/backUp.component";
import { UpdateWebAppComponent } from "./components/header/update-web-app/update-web-app.component";
import { DelinoNotificationComponent } from "./components/header/delino-newOrder-notification/delino-notification.component";

const BASE_MODULES = [CommonModule, FormsModule, ReactiveFormsModule];

const COMPONENTS = [
  HeaderComponent,
  CallinfoComponent,
  backUpComponent,
  ImportAndExportComponent,
  UpdateWebAppComponent,
  DelinoNotificationComponent,
];

const ENTRY_COMPONENTS = [];

const PIPES = [CapitalizePipe, PluralPipe, RoundPipe, TimingPipe, NumberWithCommasPipe];

@NgModule({
  imports: [...BASE_MODULES, SharedModule],
  exports: [...BASE_MODULES, ...COMPONENTS, ...PIPES],
  declarations: [...COMPONENTS, ...PIPES],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
    };
  }
}
